import { useMemo, lazy, Suspense } from "react";
import { useJsApiLoader } from "@react-google-maps/api";

const GoogleMapComponent = lazy(() => import("./GoogleMapComponent"));

const CusMap = () => {
  const center = useMemo(() => ({ lat: -34.397, lng: 150.644 }), []);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
    libraries: ["places"],
  });

  if (!isLoaded) return <div>Loading...</div>;

  return (
    <Suspense fallback={<div>Loading map...</div>}>
      <GoogleMapComponent center={center} />
    </Suspense>
  );
};

export default CusMap;
